<template>
  <div>
    <el-row class="form-item">
      <el-col style="margin-bottom: 15px">发货明细</el-col>
      <el-table :data="deliveryList" class="order-data-table ie-table">
        <el-table-column label="物料名称" prop="itemName"/>
        <el-table-column label="物料编码" prop="itemCode" width="200"/>
        <el-table-column label="MMR12" prop="mmr12" width="200"/>
        <el-table-column label="物料数量" prop="purchaseQuantity" width="100"/>
        <el-table-column label="地址信息">
          <template slot-scope="scope">
            {{ getAddressInfo(scope.row) }}
          </template>
        </el-table-column>
      </el-table>
      <div class="pag-row">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  props: {
    orderAddressList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      page: 1,
      pageSize: 8,
      total: null,
      deliveryList: []
    }
  },

  created () {
    this.setPage()
  },

  methods: {

    // 品牌
    getBrandName (row) {
      if (row.subBrandName) {
        return row.abiBrandName + ' - ' + row.subBrandName
      }
      return row.abiBrandName
    },

    // 渠道
    getChannelName (row) {
      if (row.subChannelName) {
        return row.channelName + ' - ' + row.subChannelName
      }
      return row.channelName
    },

    // 地址
    getAddressInfo (row) {
      return `${row.provinceName}-${row.cityName}-${row.countyName}-${row.detailAddress}，${row.receivePerson}: ${row.receivePhone}`
    },

    setPage () {
      this.total = this.orderAddressList.length
      this.pageLoadData(1)
    },

    // 分页
    pageLoadData (page) {
      this.deliveryList = this.orderAddressList.slice((page - 1) * this.pageSize, page * this.pageSize)
    },

    handleCurrentChange (val) {
      this.pageLoadData(val)
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item {
  padding: $content-large;
  .pag-row {
    margin-top: $content-middle;
  }
}
</style>
